import { Link } from "office-ui-fabric-react"

const WorkWeekTooltip = () => {
    return <div>
        Select a calendar for this resource, and choose whether the resource uses the calendar's work week settings
        or personal work week settings in the resource plans and task assignments.
        <ul style={{ paddingLeft: 0, listStylePosition: 'inside' }}>
            <li>
                <b>Calendar work week used:</b> the calendar's work week applies, together with the calendar's exceptions and this resource's personal exceptions.
            </li>
            <li>
                <b>Personal work week used:</b> the resource's personal work week applies instead, together with the calendar's exceptions
                and this resource's personal exceptions.
            </li>
        </ul>
        Calendar exceptions and personal exceptions are always applied, regardless of which work week setting is used.
        <br />
        <br />
        Changing these settings requires "Manage Resources" permission.
        See the <Link href="https://help.ppm.express/ppm-express-settings/621569-calendar" target="_blank">article</Link> for details.
    </div>;
}

export default WorkWeekTooltip;